export default __webpack_public_path__ + "media/images/main_back-3ba761e69f9f98da8384507416e085ee.png";